
export default function TeaStory() {
  const features = [
    {
      icon: 'ri-plant-line',
      title: 'シングルオリジン',
      desc: '静岡・鹿児島など日本各地の茶園から、単一産地・単一品種の茶葉を厳選',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '職人の手摘み',
      desc: '熟練の茶師が丁寧に選別した、最高品質の茶葉のみを使用',
    },
    {
      icon: 'ri-timer-line',
      title: '鮮度へのこだわり',
      desc: '焙煎後すぐにパッキング。届いた瞬間が最も美味しい状態',
    },
  ];

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#FAF8F5]" aria-labelledby="tea-story-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-20 items-center">
          <div>
            <span className="inline-block px-3 py-1.5 bg-[#7B8C3E]/10 text-[#7B8C3E] text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
              ABOUT CRAFT TEA
            </span>
            <h2 id="tea-story-heading" className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-6 sm:mb-8 tracking-[0.05em] leading-tight">
              厳選された<br />日本茶の世界
            </h2>
            <p className="text-sm sm:text-base text-black/60 font-extralight leading-relaxed mb-8 sm:mb-10 tracking-wide">
              Craft Teaは「よいお茶を、いつもそばに」をコンセプトに、日本各地の優れた茶園から厳選したシングルオリジンの日本茶・和紅茶を提供しています。MeVERとのコラボレーションにより、クリエイターのデスクに最高の一杯をお届けします。
            </p>

            <div className="space-y-6 sm:space-y-8">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4 sm:gap-5">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#7B8C3E]/10 rounded-xl flex-shrink-0">
                    <i className={`${feature.icon} text-xl sm:text-2xl text-[#7B8C3E]`} aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-light text-black mb-1 tracking-wide">{feature.title}</h3>
                    <p className="text-sm text-black/60 font-extralight leading-relaxed">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:gap-6">
            <div className="space-y-4 sm:space-y-6">
              <div className="aspect-[3/4] rounded-xl sm:rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/9deab2f8d5f5e045c13472aedfc79c6c.jpg"
                  alt="厳選された日本茶の茶葉"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="533"
                />
              </div>
              <div className="aspect-square rounded-xl sm:rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Japanese%20tea%20plantation%20rows%20of%20green%20tea%20bushes%20in%20morning%20mist%20Shizuoka%20Japan%20aerial%20view%20beautiful%20landscape%20warm%20golden%20hour%20lighting%20serene%20atmosphere&width=400&height=400&seq=teastory002&orientation=squarish"
                  alt="静岡の茶畑"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="400"
                />
              </div>
            </div>
            <div className="space-y-4 sm:space-y-6 pt-8 sm:pt-12">
              <div className="aspect-square rounded-xl sm:rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=hand%20pouring%20Japanese%20green%20tea%20from%20kyusu%20teapot%20into%20small%20ceramic%20cup%20steam%20rising%20warm%20ambient%20lighting%20minimalist%20zen%20aesthetic%20professional%20food%20photography&width=400&height=400&seq=teastory003&orientation=squarish"
                  alt="急須から注がれる日本茶"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="400"
                />
              </div>
              <div className="aspect-[3/4] rounded-xl sm:rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20Japanese%20tea%20bag%20sachets%20in%20kraft%20paper%20packaging%20minimalist%20design%20on%20wooden%20desk%20with%20laptop%20creative%20workspace%20warm%20natural%20lighting%20professional%20product%20photography&width=400&height=533&seq=teastory004&orientation=portrait"
                  alt="Craft Teaのティーバッグパッケージ"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="533"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
